import { render, staticRenderFns } from "./v-shell.vue?vue&type=template&id=6556de96&scoped=true&"
import script from "./v-shell.vue?vue&type=script&lang=js&"
export * from "./v-shell.vue?vue&type=script&lang=js&"
import style0 from "./v-shell.vue?vue&type=style&index=0&id=6556de96&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556de96",
  null
  
)

export default component.exports